import { useState, useEffect } from "react";
import axios from "axios";
import { CheckCircle2, Clock, Lightbulb, Sparkles, ArrowLeft, Loader2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { API } from "@/utils/constants";

const STATUS_ICONS = {
  "Shipped": CheckCircle2,
  "In Progress": Clock,
  "Planned": Lightbulb,
  "Considering": Sparkles,
};

export const RoadmapView = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const r = await axios.get(`${API}/roadmap`);
        setData(r.data);
      } catch {}
      setLoading(false);
    };
    fetch();
  }, []);

  if (loading) return <div className="p-6 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;

  return (
    <div className="p-4 sm:p-6 max-w-4xl mx-auto">
      <div className="mb-8">
        <h2 className="text-xl font-bold mb-1 flex items-center gap-2" data-testid="roadmap-title">
          <Lightbulb className="h-5 w-5 text-primary" />Product Roadmap
        </h2>
        <p className="text-sm text-muted-foreground">See what we've shipped, what we're building, and what's coming next</p>
      </div>

      <div className="space-y-8">
        {data?.categories?.map((cat, ci) => {
          const Icon = STATUS_ICONS[cat.name] || Sparkles;
          return (
            <div key={ci} data-testid={`roadmap-category-${ci}`}>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${cat.color}15` }}>
                  <Icon className="h-4 w-4" style={{ color: cat.color }} />
                </div>
                <h3 className="font-semibold">{cat.name}</h3>
                <Badge variant="outline" className="text-xs">{cat.items.length}</Badge>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pl-10">
                {cat.items.map((item, ii) => (
                  <div key={ii} className="p-4 bg-card border rounded-xl hover:shadow-sm transition-shadow">
                    <div className="flex items-start gap-2">
                      <div className="w-2 h-2 rounded-full mt-1.5 shrink-0" style={{ backgroundColor: cat.color }} />
                      <div>
                        <h4 className="text-sm font-medium">{item.title}</h4>
                        <p className="text-xs text-muted-foreground mt-0.5">{item.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
